var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeDots = function SvgThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 8,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.8,
    cy: 3.8,
    r: 3.8,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 3.8,
    r: 3.8,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2,
    cy: 3.8,
    r: 3.8,
    fill: "#696974"
  })));
};
export { SvgThreeDots as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/OmniSearch/_components/OmniSearchDesktopPopup/assets/three-dots.7dbef10d7f715fd93d0f23bc5762dc66.svg";